const trendsDE = {
    "view": {
        "form": {
            "label": {
                "filters": "Filter",
                "period": "Zeitraum",
                "store": "Shop",
                "label": "Label",
                "release": "Veröffentlichung",
                "track": "Titel",
                "subuser": "Unterbenutzer",
                "fetchingTrends": "Trends aus der Datenbank abrufen"
            },
            "button": {
                "resetFilters": "Filter zurücksetzen"
            },
            "options": {
                "store": {
                    "allStores": "Alle Shops",
                    "downloadStores": "Download-Shops",
                    "streamingStores": "Streaming-Shops",
                    "streamStores": "Stream-Shops"
                },
                "label": {
                    "allLabels": "Alle Labels"
                },
                "release": {
                    "allReleases": "Alle Veröffentlichungen"
                },
                "track": {
                    "allTracks": "Alle Titel"
                },
                "subuser": {
                    "selectSubuser": "Unterbenutzer auswählen"
                },
                "period": {
                    "last7Days": "Letzte 7 Tage",
                    "last14Days": "Letzte 14 Tage",
                    "last30Days": "Letzte 30 Tage",
                    "last45Days": "Letzte 45 Tage",
                    "last60Days": "Letzte 60 Tage",
                    "last75Days": "Letzte 75 Tage",
                    "last90Days": "Letzte 90 Tage"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Künstler",
                    "songMixName": "Song/Mix Name",
                    "numberOfSales": "Anzahl der Verkäufe"
                }
            }
        },
        "storeWiseSales": {
            "title": "Shopweise Verkäufe",
            "label": {
                "amazonMusicStream": "Amazon Music Stream",
                "appleMusicStream": "Apple Music Stream",
                "beatportStream": "Beatport Stream",
                "deezerStream": "Deezer Stream",
                "facebookStream": "Facebook Stream",
                "instagramStream": "Instagram Stream",
                "itunesDownload": "iTunes Download",
                "pandoraStream": "Pandora Stream",
                "soundcloudStream": "SoundCloud Stream",
                "spotifyStream": "Spotify Stream",
                "tiktokStream": "Tiktok Stream",
                "traxsourceStream": "Traxsource Stream",
                "youtubeStream": "Youtube Stream",
                "youtubePremiumStream": "Youtube Premium Stream",
                "totalSales": "Gesamtverkäufe",
                "storeMessage": "* Shop-Labels sind alphabetisch geordnet (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Verkäufe nach Gebiet"
        },
        "salesByGender": {
            "title": "Verkäufe nach Geschlecht",
            "label": {
                "male": "Männlich",
                "female": "Weiblich",
                "nonBinary": "Nicht-binär",
                "unknown": "Unbekannt"
            }
        },
        "salesByAge": {
            "title": "Verkäufe nach Alter",
            "label": {
                "male": "Männlich",
                "female": "Weiblich",
                "genderOther": "Nicht-binär",
                "unknown": "Unbekannt",
                "ageWiseSales": "Verkäufe nach Alter",
                "ageUnknown": "Alter unbekannt"
            }
        },
        "message": {
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen.",
            "subscriptionExpired": "Ihr Abonnement ist abgelaufen. Bitte <1>setzen</1> Sie Ihr Abonnement fort, um diese Funktion zu nutzen.",
            "subscriptionUpgrade": "Ihr aktueller Abonnementplan unterstützt diese Funktion nicht. Bitte <1>aktualisieren</1> Sie Ihren Abonnementplan, um diese Funktion zu nutzen."
        }
    }
};

export default trendsDE;